import { DisableDatesFunction } from "@/src/design_system/form_elements/datepicker/types/datepicker";
import { ObjectValues } from "@/src/shared/types/objectValues";

export interface DSDatePickerCalendarProps {
  disabled: boolean;
  disabledDates?: DisableDatesFunction;
}

export const DS_DATEPICKER_CALENDAR_MODES = {
  Month: "month",
  Year: "year",
  Date: "date",
} as const;

export type DSDatepickerCalendarMode = ObjectValues<typeof DS_DATEPICKER_CALENDAR_MODES>;
